import { TUser } from '@novafuturltd/core'
import { AxiosResponse } from 'axios'
import { Dispatch, SetStateAction, useState } from 'react'
import { useQuery, UseQueryResult } from 'react-query'
import get from '../api/auth/users'

interface Props {
  initEnabled?: boolean
}

type TData = AxiosResponse<TUser[]>

interface TError {} // TODO @goughjo03 find out what this error type is

export type UseUsersQuery = UseQueryResult<TData, TError> & {
  enabled: boolean
  setEnabled: Dispatch<SetStateAction<boolean>>
}

const useUsersQuery = ({ initEnabled = true }: Props): UseUsersQuery => {
  const [enabled, setEnabled] = useState<boolean>(initEnabled)
  const query = useQuery<{}, TError, TData>(
    ['usersHook', enabled],
    () => get(),
    {
      enabled,
    },
  )
  return {
    ...query,
    enabled,
    setEnabled,
  }
}

export default useUsersQuery
